import React, { useState } from 'react'
import { CarBrand } from '../../../types/modules/admin/carBrand.type'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import UpdateCarBrandForm from './UpdateCarBrandForm'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    carBrand:CarBrand
}

function CarBrandItem({carBrand}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = carBrand.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = carBrand.languages.find(s=>s.languageCode==="ar")?.name ||"";
  return (
    <>
    <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {formatNumber(carBrand.id)}
        </td>
     <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {arName}
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateCarBrand]}>
            <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
                <button onClick={()=>setIsOpen(p=>!p)}>
                    <Edit/>
                </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateCarBrandForm
            defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        id={carBrand.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>
    </>
  )
}

export default CarBrandItem